import React from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    question: "How does the personalisation work?",
    answer: "You upload one clear photo of your child's face. Our team transforms it into a beautiful illustrated character that appears throughout the story. The book also includes your child's name in the story text.",
  },
  {
    question: "How long does delivery take?",
    answer: "5-7 working days across India. We ship from Bangalore. Express delivery (2-3 days) available for Rs.99 extra.",
  },
  {
    question: "What age is this for?",
    answer: "Our stories are designed for children aged 3-10. We have simpler stories for younger kids and more adventurous ones for older children.",
  },
  {
    question: "Can I order in Hindi?",
    answer: "Yes! We offer books in both English and Hindi. More languages coming soon.",
  },
  {
    question: "What if I don't like how the book looks?",
    answer: "We send you a digital preview before printing. If you're not happy, we'll redo it — no questions asked.",
  },
  {
    question: "Can I order multiple copies?",
    answer: "Absolutely! We offer bulk pricing for return gifts and school events. WhatsApp us for custom quotes.",
  },
  {
    question: "What's the quality of the book?",
    answer: "Premium hardcover, 24-32 pages, thick matte-finish paper, vibrant full-colour illustrations. This is not a flimsy printout — it's a real, beautiful book.",
  },
  {
    question: "Is this available outside India?",
    answer: "Currently we deliver across India only. International shipping coming soon!",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-20 sm:py-28 bg-white relative overflow-hidden" data-testid="faq-section">
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-rose-50/60 rounded-full blur-3xl pointer-events-none" />

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="text-sm font-bold text-rose-500 uppercase tracking-widest mb-3 block">FAQ</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-indigo-950 tracking-tight" data-testid="faq-heading">
            Got Questions? We've Got Answers.
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-white rounded-2xl border border-indigo-950/5 shadow-sm px-6 hover:shadow-md transition-shadow data-[state=open]:shadow-lg data-[state=open]:border-rose-200/50"
                data-testid={`faq-item-${i + 1}`}
              >
                <AccordionTrigger className="text-left text-sm sm:text-base font-semibold text-indigo-950 hover:text-rose-500 hover:no-underline py-5 [&[data-state=open]]:text-rose-500">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-indigo-950/60 leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
